import { take, call, put } from 'redux-saga/effects'
import { apiSaga, formSaga } from './sagas'
import { callApi } from '../../api/api'
import { normalizeUserCreationError } from '../../util/errorUtils'

// ------------------------------------
// Action Types & Creators
// ------------------------------------

export const ADD_FRIEND_REQUEST = 'foodsby/friends/ADD_FRIEND_REQUEST'
export const ADD_FRIEND_REQUEST_SUCCESS =
  'foodsby/friends/ADD_FRIEND_REQUEST_SUCCESS'
export const ADD_FRIEND_REQUEST_FAILURE =
  'foodsby/friends/ADD_FRIEND_REQUEST_FAILURE'

export const LOAD_FRIENDS = 'foodsby/friends/LOAD_FRIENDS'
export const LOAD_FRIENDS_SUCCESS = 'foodsby/friends/LOAD_FRIENDS_SUCCESS'
export const LOAD_FRIENDS_FAILURE = 'foodsby/friends/LOAD_FRIENDS_FAILURE'

export const LOAD_FRIENDS_FAVORITES = 'foodsby/friends/LOAD_FRIENDS_FAVORITES'
export const LOAD_FRIENDS_FAVORITES_SUCCESS =
  'foodsby/friends/LOAD_FRIENDS_FAVORITES_SUCCESS'
export const LOAD_FRIENDS_FAVORITES_FAILURE =
  'foodsby/friends/LOAD_FRIENDS_FAVORITES_FAILURE'

export const DELETE_FRIEND = 'foodsby/friends/DELETE_FRIEND'
export const DELETE_FRIEND_SUCCESS = 'foodsby/friends/DELETE_FRIEND_SUCCESS'
export const DELETE_FRIEND_FAILURE = 'foodsby/friends/DELETE_FRIEND_FAILURE'

export const FRIEND_REQUEST_RESPONSE = 'foodsby/friends/FRIEND_REQUEST_RESPONSE'
export const FRIEND_REQUEST_RESPONSE_SUCCESS =
  'foodsby/friends/FRIEND_REQUEST_RESPONSE_SUCCESS'
export const FRIEND_REQUEST_RESPONSE_FAILURE =
  'foodsby/friends/FRIEND_REQUEST_RESPONSE_FAILURE'

export const GET_INCOMING_FRIEND_REQUESTS =
  'foodsby/friends/GET_INCOMING_FRIEND_REQUESTS'
export const GET_INCOMING_FRIEND_REQUESTS_SUCCESS =
  'foodsby/friends/GET_INCOMING_FRIEND_REQUESTS_SUCCESS'
export const GET_INCOMING_FRIEND_REQUESTS_FAILURE =
  'foodsby/friends/GET_INCOMING_FRIEND_REQUESTS_FAILURE'

export const GET_OUTGOING_FRIEND_REQUESTS =
  'foodsby/friends/GET_OUTGOING_FRIEND_REQUESTS'
export const GET_OUTGOING_FRIEND_REQUESTS_SUCCESS =
  'foodsby/friends/GET_OUTGOING_FRIEND_REQUESTS_SUCCESS'
export const GET_OUTGOING_FRIEND_REQUESTS_FAILURE =
  'foodsby/friends/GET_OUTGOING_FRIEND_REQUESTS_FAILURE'

export const GET_FRIEND_REQUEST_COUNT =
  'foodsby/friends/GET_FRIEND_REQUEST_COUNT'
export const GET_FRIEND_REQUEST_COUNT_SUCCESS =
  'foodsby/friends/GET_FRIENDS_REQUEST_COUNT_SUCCESS'
export const GET_FRIEND_REQUEST_COUNT_FAILURE =
  'foodsby/friends/GET_FRIENDS_REQUEST_COUNT_FAILURE'

export const CANCEL_OUTGOING_FRIEND_REQUEST =
  'foodsby/friends/CANCEL_OUTGOING_FRIEND_REQUEST'
export const CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS =
  'foodsby/friends/CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS'
export const CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE =
  'foodsby/friends/CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE'

export const GET_FRIENDS_ORDERS = 'foodsby/friends/GET_FRIENDS_ORDERS'
export const GET_FRIENDS_ORDERS_SUCCESS =
  'foodsby/friends/GET_FRIENDS_ORDERS_SUCCESS'
export const GET_FRIENDS_ORDERS_FAILURE =
  'foodsby/friends/GET_FRIENDS_ORDERS_FAILURE'

export const addFriendStart = email => {
  return {
    type: ADD_FRIEND_REQUEST,
    payload: { email }
  }
}

export const addFriendRequestSuccess = response => {
  return {
    type: ADD_FRIEND_REQUEST_SUCCESS,
    payload: { response }
  }
}

export const addFriendRequestFailure = error => {
  return {
    type: ADD_FRIEND_REQUEST_FAILURE,
    error
  }
}

export const loadFriendsStart = () => {
  return {
    type: LOAD_FRIENDS
  }
}

export const loadFriendsSuccess = friends => {
  return {
    type: LOAD_FRIENDS_SUCCESS,
    payload: { friends }
  }
}

export const loadFriendsFailure = error => {
  return {
    type: LOAD_FRIENDS_FAILURE,
    error
  }
}
export const loadFriendsFavorites = menuItemId => {
  return {
    type: LOAD_FRIENDS_FAVORITES,
    payload: { menuItemId }
  }
}

export const loadFriendsFavoritesSuccess = friendsFavorites => {
  return {
    type: LOAD_FRIENDS_FAVORITES_SUCCESS,
    payload: { friendsFavorites }
  }
}

export const loadFriendsFavoritesFailure = error => {
  return {
    type: LOAD_FRIENDS_FAVORITES_FAILURE,
    error
  }
}

export const getIncomingFriendRequests = type => {
  return {
    type: GET_INCOMING_FRIEND_REQUESTS,
    payload: { type }
  }
}

export const getIncomingFriendRequestsSuccess = response => {
  return {
    type: GET_INCOMING_FRIEND_REQUESTS_SUCCESS,
    payload: { response }
  }
}

export const getIncomingFriendRequestsFailure = error => {
  return {
    type: GET_INCOMING_FRIEND_REQUESTS_FAILURE,
    error
  }
}

export const getOutgoingFriendRequests = type => {
  return {
    type: GET_OUTGOING_FRIEND_REQUESTS,
    payload: { type }
  }
}

export const getOutgoingFriendRequestsSuccess = response => {
  return {
    type: GET_OUTGOING_FRIEND_REQUESTS_SUCCESS,
    payload: { response }
  }
}

export const getOutgoingFriendRequestsFailure = error => {
  return {
    type: GET_OUTGOING_FRIEND_REQUESTS_FAILURE,
    error
  }
}

export const getFriendRequestCount = type => {
  return {
    type: GET_FRIEND_REQUEST_COUNT,
    payload: { type }
  }
}

export const getFriendRequestCountSuccess = response => {
  return {
    type: GET_FRIEND_REQUEST_COUNT_SUCCESS,
    payload: { response }
  }
}

export const getFriendRequestCountFailure = error => {
  return {
    type: GET_FRIEND_REQUEST_COUNT_FAILURE,
    error
  }
}

export const friendRequestResponse = response => {
  return {
    type: FRIEND_REQUEST_RESPONSE,
    payload: { response }
  }
}

export const friendRequestReponseSuccess = () => {
  return {
    type: FRIEND_REQUEST_RESPONSE_SUCCESS
  }
}

export const friendRequestResponseFailure = error => {
  return {
    type: FRIEND_REQUEST_RESPONSE_FAILURE,
    error
  }
}

export const cancelOutgoingFriendRequest = id => {
  return {
    type: CANCEL_OUTGOING_FRIEND_REQUEST,
    payload: { id }
  }
}

export const cancelOutgoingFriendRequestSuccess = () => {
  return {
    type: CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS
  }
}

export const cancelOutgoingFriendRequestFailure = error => {
  return {
    type: CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE,
    error
  }
}

export const deleteCurrentFriend = id => {
  return {
    type: DELETE_FRIEND,
    payload: { id }
  }
}

export const deleteCurrentFriendSuccess = () => {
  return {
    type: DELETE_FRIEND_SUCCESS
  }
}

export const deleteCurrentFriendFailure = error => {
  return {
    type: DELETE_FRIEND_FAILURE,
    error
  }
}

export const getFriendsOrdersStart = (date, location = '') => {
  return {
    type: GET_FRIENDS_ORDERS,
    payload: { date, location }
  }
}

export const getFriendsOrdersSuccess = response => {
  return {
    type: GET_FRIENDS_ORDERS_SUCCESS,
    payload: { response }
  }
}

export const getFriendsOrdersFailure = error => {
  return {
    type: GET_FRIENDS_ORDERS_FAILURE,
    error
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [ADD_FRIEND_REQUEST]: (state, action) => {
    return {
      ...state,
      success: undefined,
      isAddingFriends: true,
      sendFriendRequestError: undefined
    }
  },
  [ADD_FRIEND_REQUEST_SUCCESS]: (state, action) => {
    const response = action.payload.response.type
    return {
      ...state,
      success: response !== 'FRIENDS',
      isAddingFriends: false,
      sendFriendRequestError:
        response === 'FRIENDS'
          ? 'You are already friends with that person'
          : undefined
    }
  },
  [ADD_FRIEND_REQUEST_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      success: undefined,
      isAddingFriends: false,
      sendFriendRequestError: error
    }
  },
  [LOAD_FRIENDS]: state => {
    return {
      ...state,
      success: undefined,
      isLoadingFriends: true,
      loadFriendsError: undefined,
      sendFriendRequestError: undefined,
      friendRequestLoadingError: undefined
    }
  },
  [LOAD_FRIENDS_SUCCESS]: (state, action) => {
    const friends = action.payload.friends.content
    return {
      ...state,
      isLoadingFriends: false,
      friends
    }
  },
  [LOAD_FRIENDS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriends: false,
      loadFriendsError: error
    }
  },
  [LOAD_FRIENDS_FAVORITES]: state => {
    return {
      ...state,
      isLoadingFavorites: true,
      loadFriendsFavoritesError: undefined
    }
  },
  [LOAD_FRIENDS_FAVORITES_SUCCESS]: (state, action) => {
    const { friendsFavorites } = action.payload
    return {
      ...state,
      isLoadingFavorites: false,
      friendsFavorites
    }
  },
  [LOAD_FRIENDS_FAVORITES_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFavorites: false,
      loadFriendsFavoritesError: error
    }
  },
  [GET_INCOMING_FRIEND_REQUESTS]: state => {
    return {
      ...state,
      isLoadingFriendRequests: true
    }
  },
  [GET_INCOMING_FRIEND_REQUESTS_SUCCESS]: (state, action) => {
    const incomingFriendRequests = action.payload.response.content
    return {
      ...state,
      isLoadingFriendRequests: false,
      incomingFriendRequests
    }
  },
  [GET_INCOMING_FRIEND_REQUESTS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendRequests: false,
      friendRequestLoadingError: error
    }
  },
  [GET_OUTGOING_FRIEND_REQUESTS]: state => {
    return {
      ...state,
      isLoadingFriendRequests: true
    }
  },
  [GET_OUTGOING_FRIEND_REQUESTS_SUCCESS]: (state, action) => {
    const outgoingFriendRequests = action.payload.response.content
    return {
      ...state,
      isLoadingFriendRequests: false,
      outgoingFriendRequests
    }
  },
  [GET_OUTGOING_FRIEND_REQUESTS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendRequests: false,
      friendRequestLoadingError: error
    }
  },
  [GET_FRIEND_REQUEST_COUNT]: state => {
    return {
      ...state,
      isLoadingRequestCount: true
    }
  },
  [GET_FRIEND_REQUEST_COUNT_SUCCESS]: (state, action) => {
    const requestCount = action.payload.response
    return {
      ...state,
      isLoadingRequestCount: false,
      requestCount
    }
  },
  [GET_FRIEND_REQUEST_COUNT_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingRequestCount: false,
      requestCountError: error
    }
  },
  [FRIEND_REQUEST_RESPONSE]: state => {
    return {
      ...state,
      isRespondingToFriendRequest: true
    }
  },
  [FRIEND_REQUEST_RESPONSE_SUCCESS]: (state, action) => {
    return {
      ...state,
      isRespondingToFriendRequest: false
    }
  },
  [FRIEND_REQUEST_RESPONSE_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      friendRequestResponseError: error,
      isRespondingToFriendRequest: false
    }
  },
  [CANCEL_OUTGOING_FRIEND_REQUEST]: state => {
    return {
      ...state,
      isCancelingOutgoingRequest: true
    }
  },
  [CANCEL_OUTGOING_FRIEND_REQUEST_SUCCESS]: (state, action) => {
    return {
      ...state,
      isCancelingOutgoingRequest: false
    }
  },
  [CANCEL_OUTGOING_FRIEND_REQUEST_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isCancelingOutgoingRequest: false,
      cancelOutgoingRequestError: error
    }
  },
  [DELETE_FRIEND]: state => {
    return {
      ...state,
      isDeletingFriend: true
    }
  },
  [DELETE_FRIEND_SUCCESS]: state => {
    return {
      ...state,
      isDeletingFriend: false
    }
  },
  [DELETE_FRIEND_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isDeletingFriend: false,
      deletingFriendError: error
    }
  },
  [GET_FRIENDS_ORDERS]: state => {
    return {
      ...state,
      isLoadingFriendsOrders: true
    }
  },
  [GET_FRIENDS_ORDERS_SUCCESS]: (state, action) => {
    let friendNotOrdered
    let friendHasOrdered = []
    let friendsOrderCount = []
    if (action.payload.response) {
      action.payload.response.forEach(order => {
        if (order.dropoffId === null) {
          friendNotOrdered = order.friends
        } else if (order.dropoffId !== null) {
          friendHasOrdered.push(order)
          friendsOrderCount.push(order.friends)
        }
      })
    }
    return {
      ...state,
      isLoadingFriendsOrders: false,
      friendNotOrdered,
      friendHasOrdered,
      friendsOrderCount
    }
  },
  [GET_FRIENDS_ORDERS_FAILURE]: (state, action) => {
    const error = normalizeUserCreationError(action.error.response)
    return {
      ...state,
      isLoadingFriendsOrders: false,
      friendsOrdersError: error
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  favorites: []
}

export default function friends(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------

export function* watchSendNewFriendRequest() {
  while (true) {
    const {
      payload: { email }
    } = yield take(ADD_FRIEND_REQUEST)
    yield call(
      formSaga,
      'friendRequestForm',
      addNewFriendRequest,
      [email],
      addFriendRequestSuccess,
      addFriendRequestFailure
    )
  }
}

export function* watchLoadCurrentFriends() {
  while (true) {
    yield take(LOAD_FRIENDS)
    yield call(
      apiSaga,
      getMyFriends,
      [],
      loadFriendsSuccess,
      loadFriendsFailure
    )
  }
}

export function* watchLoadFriendsSuccess() {
  while (true) {
    yield take(LOAD_FRIENDS_SUCCESS)
    yield put(getIncomingFriendRequests('INCOMING'))
    yield put(getOutgoingFriendRequests('OUTGOING'))
    yield put(getFriendRequestCount('INCOMING'))
  }
}

export function* watchLoadIncomingFriendRequests() {
  while (true) {
    const {
      payload: { type }
    } = yield take(GET_INCOMING_FRIEND_REQUESTS)
    yield call(
      apiSaga,
      getMyFriendRequests,
      [type],
      getIncomingFriendRequestsSuccess,
      getIncomingFriendRequestsFailure
    )
  }
}

export function* watchLoadOutgoingFriendRequests() {
  while (true) {
    const {
      payload: { type }
    } = yield take(GET_OUTGOING_FRIEND_REQUESTS)
    yield call(
      apiSaga,
      getMyFriendRequests,
      [type],
      getOutgoingFriendRequestsSuccess,
      getOutgoingFriendRequestsFailure
    )
  }
}

export function* watchLoadFriendsFavorites() {
  while (true) {
    const {
      payload: { menuItemId }
    } = yield take(LOAD_FRIENDS_FAVORITES)
    yield call(
      apiSaga,
      friendsFavorites,
      [menuItemId],
      loadFriendsFavoritesSuccess,
      loadFriendsFavoritesFailure
    )
  }
}

export function* watchRespondingToFriendRequests() {
  while (true) {
    const {
      payload: { response }
    } = yield take(FRIEND_REQUEST_RESPONSE)
    yield call(
      apiSaga,
      respondToFriendRequest,
      [response],
      friendRequestReponseSuccess,
      friendRequestResponseFailure
    )
  }
}

export function* watchFriendRequestResponseSuccess() {
  while (true) {
    yield take([ADD_FRIEND_REQUEST_SUCCESS, FRIEND_REQUEST_RESPONSE_SUCCESS])
    yield put(loadFriendsStart())
  }
}

export function* watchLoadFriendRequestCount() {
  while (true) {
    const {
      payload: { type }
    } = yield take(GET_FRIEND_REQUEST_COUNT)
    yield call(
      apiSaga,
      getMyFriendRequestCount,
      [type],
      getFriendRequestCountSuccess,
      getFriendRequestCountFailure
    )
  }
}

export function* watchDeleteFriend() {
  while (true) {
    const {
      payload: { id }
    } = yield take(DELETE_FRIEND)
    yield call(
      apiSaga,
      deleteFriend,
      [id],
      deleteCurrentFriendSuccess,
      deleteCurrentFriendFailure
    )
    yield put(loadFriendsStart())
  }
}

export function* watchCancelOutgoingRequest() {
  while (true) {
    const {
      payload: { id }
    } = yield take(CANCEL_OUTGOING_FRIEND_REQUEST)
    yield call(
      apiSaga,
      cancelOutgoingRequest,
      [id],
      cancelOutgoingFriendRequestSuccess,
      cancelOutgoingFriendRequestFailure
    )
    yield put(loadFriendsStart())
  }
}

export function* watchGetFriendsOrders() {
  while (true) {
    const {
      payload: { date, location }
    } = yield take(GET_FRIENDS_ORDERS)
    yield call(
      apiSaga,
      getFriendsOrders,
      [date, location],
      getFriendsOrdersSuccess,
      getFriendsOrdersFailure
    )
  }
}

// ------------------------------------
// APIs
// ------------------------------------

export const addNewFriendRequest = email =>
  callApi.post(`/api/v1/connections/friendships`, email)

export const getMyFriends = () => callApi.get(`/api/v1/connections/friends`)

export const getMyFriendRequests = type =>
  callApi.get(`/api/v1/connections/friendships/requests?direction=${type}`)

export const getMyFriendRequestCount = type =>
  callApi.get(
    `/api/v1/connections/friendships/requests/count?direction=${type}`
  )

export const respondToFriendRequest = response =>
  callApi.patch(`/api/v1/connections/friendships`, response)

export const deleteFriend = id =>
  callApi.delete(`/api/v1/connections/friendships/${id}`)

export const cancelOutgoingRequest = id =>
  callApi.delete(`/api/v1/connections/friendships/requests/${id}`)

export const getFriendsOrders = (date, location) =>
  callApi.get(
    `/api/v1/connections/friends/orders?date=${date}&location=${location}`
  )

export const friendsFavorites = menuItemId =>
  callApi.get(`/api/v1/connections/friends-favorites?menuItemId=${menuItemId}`)
